module.exports = __webpack_public_path__ + "static/media/calendar.8ee1b623.svg";